var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 48,
    viewBox: "0 0 56 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H52C53.933 0.5 55.5 2.067 55.5 4V44C55.5 45.933 53.933 47.5 52 47.5H4C2.067 47.5 0.5 45.933 0.5 44V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H52C53.933 0.5 55.5 2.067 55.5 4V44C55.5 45.933 53.933 47.5 52 47.5H4C2.067 47.5 0.5 45.933 0.5 44V4Z",
    stroke: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7071 17.2929C27.0976 17.6834 27.0976 18.3166 26.7071 18.7071L22.414 23.0002H36C36.5523 23.0002 37 23.448 37 24.0002C37 24.5525 36.5523 25.0002 36 25.0002H22.4145L26.7071 29.2929C27.0976 29.6834 27.0976 30.3166 26.7071 30.7071C26.3166 31.0976 25.6834 31.0976 25.2929 30.7071L19.3054 24.7197C19.1297 24.55 19.016 24.3165 19.0016 24.0565C18.998 23.9925 19.0005 23.9282 19.0092 23.8645C19.0135 23.8329 19.0192 23.8017 19.0264 23.771C19.0675 23.5958 19.1563 23.4295 19.2929 23.2929L25.2929 17.2929C25.6834 16.9024 26.3166 16.9024 26.7071 17.2929Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.2d604a7963f1646eebf0ef4db3f98022.svg";
export { ForwardRef as ReactComponent };